import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import MainContent from '../../../common/MainContent';

const useStyles = makeStyles(() => ({
  container: {
    padding: '0px 16px',
    marginTop: 24,
    marginBottom: 20,
  },
}));

const Content = () => {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.container}>
      <MainContent mobile={true} />
    </Paper>
  );
};

export default Content;
